<template>
  <div class="button-holder view-toggle">
    <button
      class="toggle-button"
      :class="{'active': displayStyle === 'grid'}" @click="toggleDisplayStyle('grid')">
        <i class="fas fa-th"></i> <span class="button-text">Grid View</span>
    </button>
    <button
      class="toggle-button"
      :class="{'active': displayStyle === 'list'}" @click="toggleDisplayStyle('list')">
        <i class="fas fa-list"></i> <span class="button-text">List View</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ViewToggle',
  props: {
    displayStyle: {
      type: String,
      required: true
    }
  },
  methods: {
    toggleDisplayStyle(display) {
      this.$emit('toggled', { display });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.button-holder {
  text-align: left;
  padding-top: 0;
  
  .toggle-button {
    margin-right: 10px;
    width: auto;
  }
}

.toggle-button {
  // font-size: 14px;
  padding: 5px 10px;
  border-radius: 3px;
  border: 1px solid $accent-color;
  transition: background-color .3s, color .3s;

  i,
  span {
    color: $accent-color;
    font-weight: bold;
  }

  &:hover {
    background-color: $accent-color;
    color: #fff;

    i,
    span {
      color: #fff;
    }
  }

  &.active {
    border-color: $dark-blue;
    background-color: $dark-blue;
    color: #fff;

    i,
    span {
      color: #fff;
    }
  }

  .button-text {
    font-size: 14px;
    padding-left: 10px;
  }
}

.view-toggle {
  margin-top: 40px;
}
</style>


